import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs/operators';
import { ActionCreatorWithProps } from 'src/app/shared/types/action-creator.type';

export type SnackbarEffectCreatorArgs<TActionProps = any> = {
  initiatingAction: ActionCreatorWithProps<TActionProps>;
  message: (actionProps?: TActionProps) => string;
  buttonLabel?: string;
  persistent?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class SnackBarEffectCreatorService {
  constructor(private actions$: Actions, private snackBar: MatSnackBar) {}

  /**
   * Creates an effect which displays a snackbar
   * @param options options for the effect
   * @param options.initiatingAction action which triggers display of the snackbar
   * @param options.message message to display in the snack bar, if falsy no snackbar is displayed
   * @param options.buttonLabel label for the snack bar action/button, defaults to 'Dismiss'
   * @param options.persistent true if the snack bar should not auto dismiss, defaults to false
   */
  createEffect<TActionProps extends {}>(options: SnackbarEffectCreatorArgs<TActionProps>) {
    const { initiatingAction, message, buttonLabel, persistent } = options;

    return createEffect(
      () =>
        this.actions$.pipe(
          ofType(initiatingAction),
          map((props) => message(props)),
          filter((msg) => !!msg),
          tap((msg) =>
            this.snackBar.open(msg, buttonLabel || 'Dismiss', persistent ? { duration: 0 } : {}),
          ),
        ),
      { dispatch: false },
    );
  }
}
